import { createSlice } from "@reduxjs/toolkit";

const progressSlice = createSlice({
  name: "progress",
  initialState: { isAnimating: false },
  reducers: {
    startLoading: (state) => {
      state.isAnimating = true;
    },
    stopLoading: (state) => {
      state.isAnimating = false;
    },
  },
});

// Export actions
export const { startLoading, stopLoading } = progressSlice.actions;

// Export reducer
export default progressSlice.reducer;
